import React, { Fragment } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import _ from "lodash";

import { StyledMoneyInput, StyledPercentInput } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

const AssetAssumptionsSection = ({ formik }) => {
  const { values } = formik;

  return (
    <>
      <Grid item xs={10}><FormSectionTitle title="ASSET ASSUMPTIONS" /></Grid>
      <Grid item xs={10}>
        <StyledMoneyInput label="Projected NOI" fieldName="projectedNOI" />
        {" "}
      </Grid>
      <Grid item xs={10}>
        <StyledPercentInput label="Future Cap Rate" decimalScale={3} fieldName="futureCapRate" />
        {" "}
      </Grid>
    </>
  );
};
export default compose(
  connect
)(AssetAssumptionsSection);
